import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getActiveSection, getPublishedFolderId, getPublishedTierId } from '../../selectors/studio';
import { Props } from './StudioHeaderMobile';

export type StateProps = Pick<Props, 'activeSection' | 'publishedFolderId' | 'publishedTierId'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  activeSection: getActiveSection(state),
  publishedFolderId: getPublishedFolderId(state),
  publishedTierId: getPublishedTierId(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
